export const CSD_URL = 'https://www.gob.mx/tramites/ficha/certificado-de-sello-digital/SAT139';
export const ELECTRONIC_SIGNATURE_URL = 'https://citas.sat.gob.mx/';